import React, { FC } from 'react';
import {
	SummaryDatumDerEinreichung,
	SummaryNameDerOrganisation,
	SummaryOrganisationAntragberechtigtAls,
	SummaryProjektTitel,
	SummaryTitel,
} from 'src/pages/private/online-antrag/antrag-components/AbschlussSeiteSummary';
import AbschlussSeiteBox from '../../../../antrag-components/AbschlussSeiteBox';

const AbschlussSkizzeStipendium: FC<{}> = () => {
	return (
		<>
			<SummaryTitel />

			<AbschlussSeiteBox>
				<SummaryDatumDerEinreichung />

				<SummaryProjektTitel />

				<SummaryNameDerOrganisation />
				<SummaryOrganisationAntragberechtigtAls />
			</AbschlussSeiteBox>
		</>
	);
};

export default AbschlussSkizzeStipendium;
